import { BaseType } from '../../../base/base-type';

export class LeaveDetailsType extends BaseType {}
